export interface Skill {
    id: string;
    category: string;
    name: string;
    level?: number;
    icon_name?: string;
    createdAt?: number | string;
}

export type SkillCreate = Omit<Skill, 'id' | 'createdAt'>;

const API_URL = '/api/skills';

export async function getSkills(): Promise<Skill[]> {
    const res = await fetch(API_URL);
    if (!res.ok) throw new Error('Erreur lors du chargement des compétences');
    return res.json();
}

export async function createSkill(data: SkillCreate): Promise<Skill> {
    const token = localStorage.getItem('admin_token');
    const res = await fetch(API_URL, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data),
    });
    if (!res.ok) throw new Error('Erreur lors de la création');
    return res.json();
}

export async function updateSkill(id: string, data: Partial<SkillCreate>): Promise<Skill> {
    const token = localStorage.getItem('admin_token');
    const res = await fetch(`${API_URL}/${id}`, {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data),
    });
    if (!res.ok) throw new Error('Erreur lors de la modification');
    return res.json();
}

export async function deleteSkill(id: string): Promise<void> {
    const token = localStorage.getItem('admin_token');
    const res = await fetch(`${API_URL}/${id}`, {
        method: 'DELETE',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
    if (!res.ok) throw new Error('Erreur lors de la suppression');
}
